/**
 * For the education related element (element ID 11020)
 */

// IDs for the checkboxes
const TRIGGER_CHECKBOX_ID = 'item-id-11022';
const DEPENDENT_CHECKBOX_IDS = [
    'item-id-11031',
    'item-id-11032',
    'item-id-11033',
    'item-id-11034'
];

/**
 * Show the dependent checkboxes
 */
function showDependentCheckboxes(): void {
    DEPENDENT_CHECKBOX_IDS.forEach(id => {
        const $container = $(`#${id}`).closest('.form-check');
        $container.show();
    });
}

/**
 * Hide and deselect the dependent checkboxes
 */
function hideDependentCheckboxes(): void {
    DEPENDENT_CHECKBOX_IDS.forEach(id => {
        const $checkbox = $(`#${id}`);
        const $container = $checkbox.closest('.form-check');
        
        // Hide the container
        $container.hide();
        
        // Deselect the checkbox if it was selected
        if ($checkbox.is(':checked')) {
            $checkbox.prop('checked', false);
            
            // Also clear any associated free text input
            const $freeTextInput = $(`#${id}_free`);
            if ($freeTextInput.length > 0) {
                $freeTextInput.val('');
                // Reset character counter if exists
                const limitDiv = $freeTextInput.data('limit-div');
                if (limitDiv) {
                    const limit = $freeTextInput.data('limit');
                    const limitLabel = $freeTextInput.data('limit-label');
                    $(`#${limitDiv}`).text(`${limitLabel} ${limit}`);
                }
            }
        }
    });
}

/**
 * Initialize the dependent checkboxes state based on trigger checkbox
 */
function initializeDependentCheckboxes(): void {
    const $triggerCheckbox = $(`#${TRIGGER_CHECKBOX_ID}`);
    
    if ($triggerCheckbox.length === 0) {
        // Trigger checkbox not found, nothing to do
        return;
    }
    
    // Set initial state based on trigger checkbox
    if ($triggerCheckbox.is(':checked')) {
        showDependentCheckboxes();
    } else {
        hideDependentCheckboxes();
    }
    
    // Add event listener for trigger checkbox changes
    $triggerCheckbox.on('change', function() {
        if ($(this).is(':checked')) {
            showDependentCheckboxes();
        } else {
            hideDependentCheckboxes();
        }
    });
}

// noinspection JSUnusedGlobalSymbols
export default function() {
    // noinspection JSDeprecatedSymbols
    $(document).ready(function() {
        initializeDependentCheckboxes();
    });
}